module.exports = __webpack_public_path__ + "media/customizations/cai/logo-7f2a6acd0b658813fa0986b44ed69d82.png";